<template>
  <div ref="modalEl" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-pegaso">
        <div class="modal-header modal-header-pegaso">
          <div class="d-flex align-items-center gap-2 w-100">
            <span class="modal-header-pegaso-icon"><i class="fa-solid fa-bullhorn"></i></span>
            <h5 class="modal-title mb-0">Sugerencia de publicación</h5>
            <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="modal" aria-label="Cerrar"
              @click="cerrar"></button>
          </div>
        </div>
        <div class="modal-body">

          <div class="mb-2 d-flex align-items-end justify-content-between">
            <label class=" fw-semibold text-muted">Título: </label>
            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!contrato" title="Copiar título"
              @click="contrato && copiarTitulo(contrato)">
              <i class="fa-solid fa-copy me-1"></i>Copiar
            </button>
          </div>

          <textarea :value="contrato ? sugerenciaTituloVideo(contrato) : ''" class="form-control font-monospace mb-3"
            readonly rows="2"></textarea>

            <div class="mb-2 d-flex align-items-end justify-content-between">
              <label class=" fw-semibold text-muted">Descripción: </label>
            <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="!contrato"
              title="Copiar descripción" @click="contrato && copiarDescripcion(contrato)">
              <i class="fa-solid fa-copy me-1"></i>Copiar
            </button>
          </div>

          <textarea :value="contrato ? sugerenciaDescripcionVideo(contrato) : ''"
            class="form-control font-monospace mb-2" readonly rows="6"></textarea>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cerrar">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount } from 'vue';
import { Modal } from 'bootstrap';
import { limpiarBackdropModal } from '@/utils/modalCleanup';
import type { Contrato } from '@/types/contrato';
import { sugerenciaTituloVideo, sugerenciaDescripcionVideo } from '@/utils/contratoFormatters';

const props = defineProps<{
  /** Si es distinto de null, el modal se muestra. */
  contrato: Contrato | null;
}>();

const emit = defineEmits<{
  (e: 'cerrar'): void;
}>();

const modalEl = ref<HTMLElement | null>(null);
let modalInstance: InstanceType<typeof Modal> | null = null;

watch(
  () => props.contrato,
  (c) => {
    if (!modalEl.value) return;
    if (c) {
      modalInstance?.dispose();
      modalInstance = new Modal(modalEl.value, { backdrop: 'static', keyboard: false });
      modalInstance.show();
    } else {
      modalInstance?.hide();
    }
  }
);

watch(modalEl, (el) => {
  if (!el) return;
  el.addEventListener('hidden.bs.modal', () => emit('cerrar'));
}, { flush: 'post' });

onBeforeUnmount(() => {
  modalInstance?.dispose();
  modalInstance = null;
  limpiarBackdropModal();
});

function cerrar() {
  modalInstance?.hide();
  emit('cerrar');
}

function copiarTitulo(c: Contrato) {
  const texto = sugerenciaTituloVideo(c);
  if (!texto) return;
  navigator.clipboard?.writeText(texto).catch(() => { });
}

function copiarDescripcion(c: Contrato) {
  const texto = sugerenciaDescripcionVideo(c);
  if (!texto) return;
  navigator.clipboard?.writeText(texto).catch(() => { });
}
</script>
